module.exports = __webpack_public_path__ + "static/media/logo-educators.f527eb57.png";